<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Số thông báo:
                                    {{ this.createItem.requestNumber }}
                                </p>
                                <p class="font-weight-bold">
                                    Số đề nghị:
                                    {{ this.createItem.requestOrderNumber }}
                                </p>
                                <p class="font-weight-bold">
                                    Người đề nghị:
                                    {{
                                        this.requestOrder != null &&
                                        this.requestOrder.userCreateName
                                    }}
                                </p>
                                <p class="font-weight-bold">
                                    Mã kho: {{ this.warehouseCode }}
                                </p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <div>
                                <i-datepicker
                                    label="Ngày dự kiến giao hàng"
                                    v-model="createItem.dateArrived"
                                    :minDate="minDate()"
                                />
                            </div>
                            <div>
                                <v-textarea
                                    outlined
                                    label="Nội dung"
                                    rows="2"
                                    v-model="createItem.content"
                                />
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <table class="lstTable">
                                <tr>
                                    <th width="10%">{{$t('lang.material.materialType')}}</th>
                                    <th width="10%">Tên vật tư</th>
                                    <th width="10%">Đơn vị</th>
                                    <th width="10%">Đóng gói</th>
                                    <th width="10%">Số lượng đề xuất</th>
                                    <th width="10%">Số lượng dự kiến</th>
                                    <!-- <th width="10%">Tổng số lượng thực nhập</th> -->
                                    <th width="10%">Số lượng thực nhập lũy kế</th>
                                    <th width="20%">Nhà cung cấp</th>
                                    <th width="10%">Ghi chú</th>
                                    <th>{{$t('lang.common.delete')}}</th>
                                </tr>
                                <template v-for="(item, index) in lstMaterial">
                                    <tr v-if="item.row === 0" :key="index">
                                        <td style="font-weight: bold">{{item.typeName}}</td>
                                        <td colspan="7">Không có vật tư</td>
                                    </tr>
                                    <tr v-else :key="index">
                                        <td :rowspan="item.row" v-if="item.row != undefined && parseInt(item.row) > 0" style="font-weight: bold">{{item.typeName}}</td>
                                        <td style="text-align: center">{{ item.materialName }}</td>
                                        <td style="text-align: center">{{ item.unit }}</td>
                                        <td style="text-align: center">{{ item.pack }}</td>
                                        <td style="text-align: center">{{ (item.buyNumberPropose != undefined ? item.buyNumberPropose : 0) | currency }}</td>
                                        <td>
                                          <c-input-number
                                                min="0"
                                                v-model="lstMaterial[index].orderQuantity"
                                                v-on:input="setInput"
                                                @keydown="keyProcess"
                                                :id="'input_' + index"
                                                :data-index="index"
                                                style="text-align: center"
                                            />
                                        </td>
                                        <td style="text-align: center">{{ item.totalImportQuantity | currency }}</td>
                                        <!-- <td style="text-align: center">{{ item.totalImportQuantityAcc }}</td> -->
                                        <td>
                                            <v-autocomplete
                                                :items="fomarLstSupplier(lstMaterial[index])"
                                                label="Nhà cung cấp"
                                                v-model="lstMaterial[index].supplyId"
                                                item-value="partnerId"
                                                item-text="partnerName"
                                                clearable
                                            />
                                        </td>
                                        <td>
                                            <v-textarea
                                                rows="2"
                                                v-model="lstMaterial[index].pur_note"
                                            />
                                        </td>
                                        <td style="text-align: center">
                                            <v-btn icon @click="deleteItem(item)">
                                                <v-icon color="red">delete</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </template>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="onSave" :disabled="loading">
                        {{ $t("Tạo thông báo") }}
                    </v-btn>
                    <v-btn color="error" @click="onCancel" :disabled="loading">
                        {{ $t("lang.common.back") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
    name: "ImportRequestCreate",
    components: {CTextboxFloat, IDatepicker },
    data: () => {
        return {
            formName: "Tạo thông báo",
            loading: false,
            warehouseCode: "",
            materials: [],
            lstSupplier: [],
            lstMaterialType: [],
            lstMaterialTmp: [],
            lstMaterial: [],
            lstMaterialFull: [],
            lstImportWh: [],
            requestOrder: null,
            createItem: {
                areaId: 0,
                dateArrived: "",
                importTotalNumber: 0,
                invoiceDate: "",
                invoiceNumber: 0,
                rejectReason: "",
                reqOrdId: 0,
                requestDate: "",
                requestNumber: "",
                requestOrderNumber: "",
                requestTotalNumber: 0,
                status: 1,
                supplyId: 0,
                totalAfterVat: 0,
                totalAmount: 0,
                useDay: 0,
                userCreateId: "",
                userGroupId: 0,
                vat: 0,
                warehouseId: 0,
                content: "",
            },
        };
    },

    created() {
        // 2: thủ kho;  26: mua hàng
        const role = parseInt(this.$store.state.auth.user.role);
        if (role != 26 && role != 3) {
            this.$router.push({ path: '/importRequest' });
        }

        this.getMaterialFull();
        this.getSuppliers();
        this.getRequestOrder();
        this.getNextCode();
        this.createItem.userCreateId = this.$store.state.auth.user.userId;
    },

    methods: {
        //linhdx reload lai array thi moi hien thi dc c-textbox-float
        setInput(){
          this.lstMaterial = [...this.lstMaterial]
        //   console.log(this.lstMaterial)
        },
        onCancel() {
            this.$router.push({ path: '/importRequest' });
        },
        onSave() {
            
            const lstMaterial_tmp = this.lstMaterial;
            
            const totalOrderQuantity = lstMaterial_tmp.reduce((n, {orderQuantity}) => n + orderQuantity, 0);
            if (parseFloat(totalOrderQuantity) <= 0) {
                message.error("Bạn chưa nhập số lượng vật tư dự kiến giao");
                return;
            }
            for(let i = 0; i < lstMaterial_tmp.length; i++){
                let obj = lstMaterial_tmp[i];
                if(obj.orderQuantity == ''){
                    obj.orderQuantity = 0;
                }
                obj.supplyId = parseInt(obj.supplyId); 

                const orderQuantity = parseFloat(obj.orderQuantity) >= 0 ? parseFloat(obj.orderQuantity) : 0;
                const price = parseFloat(obj.price) >= 0 ? parseFloat(obj.price) : 0;
                obj.money = orderQuantity * price;

                if (!(obj.supplyId > 0)) {
                    message.error("Bạn chưa chọn nhà cung cấp");
                    return;
                }

                lstMaterial_tmp[i] = obj;
            }
            // console.log(lstMaterial_tmp);
            const createItem = this.createItem;
            createItem.requestData = JSON.stringify(lstMaterial_tmp);
            // return;
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/importRequest/save", createItem)
                .then(
                    (data) => {
                        if (data.success) {
                            message.success( this.$t("lang.common.save_success"));
                            this.onCancel();
                        } else {
                            message.error(this.$t(data.description));
                            this.loading = false;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        getRequestOrder() {
            if (this.$route.params.id) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/requestOrder/detail/" + this.$route.params.id
                    )
                    .then((data) => {
                        if (typeof data == "object") {
                            this.requestOrder = data;
                            this.createItem.reqOrdId = data.reqOrdId;
                            this.createItem.areaId = data.areaId;
                            this.createItem.requestOrderNumber = data.requestNumber;

                            this.getWarehouses(data.areaId);
                            // console.log(data.requestData);
                            const dataRequest = JSON.parse(data.requestData);
                            // console.log(JSON.parse(data.requestData));
                            if (dataRequest) {
                                this.lstMaterialType = dataRequest.materialType;
                                // const lstMaterial = dataRequest.lstMaterial.filter(function (v) {
                                //     return v.buyNumber != undefined && parseFloat(v.buyNumber) > 0;
                                // });
                                this.lstMaterialTmp = dataRequest.lstMaterial;
                                // console.log(this.lstMaterialTmp);
                            }

                            this.getImportWh(data.reqOrdId);
                        }
                    });
            }
        },
        getSuppliers() {
            axios
                .post(
                    process.env.VUE_APP_API_URL + "/partner/suppliers?pageSize=-1&page=-1",
                    {status: 1}
                )
                .then((data) => {
                    if (data.items) {
                        this.lstSupplier = data.items;
                        // console.log(this.lstSupplier);
                    }
                });
        },
        getMaterialFull() {
            axios
                .post(
                    process.env.VUE_APP_API_URL + "/material/search?pageSize=-1&page=-1", {}
                )
                .then((data) => {
                    if (data.items) {
                        this.lstMaterialFull = data.items;
                    }
                });
        },
        getWarehouses(parentId) {
            axios
                .post(
                    process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?pageSize=-1&page=-1&categoryTypeCode=WAREHOUSE",
                    { parentId }
                )
                .then((data) => {
                    if (data.items != undefined && data.items.length > 0) {
                        this.createItem.warehouseId = data.items[0].categoryId;
                        this.warehouseCode = data.items[0].categoryName;
                    }
                });
        },
        getImportWh(reqOrdId) {
            axios.post(process.env.VUE_APP_API_URL + "/requestOrder/search?page=-1&pageSize=-1", {
                status: 6,
                requestNumber: this.requestOrder.requestNumber + "A",
                byProcess: 2
            }).then(
                addditionRQ => {

                    let additions = [];
                    for(let i=0;i<addditionRQ.items.length;i++){
                        additions.push(JSON.parse(addditionRQ.items[i].requestData));
                    }

                    for(let i=0;i<this.lstMaterialTmp.length;i++){
                        let add = 0;
                        for(let j=0;j<additions.length;j++){
                            for(let h=0;h<additions[j].lstMaterial.length;h++){
                                if (this.lstMaterialTmp[i].materialId == additions[j].lstMaterial[h].materialId){
                                    add += additions[j].lstMaterial[h].buyNumberAddition;
                                }
                            }
                        }
                        this.lstMaterialTmp[i].buyNumberPropose+=add;
                    }

                    axios.post(
                        process.env.VUE_APP_API_URL + "/importWh/search?pageSize=-1&page=-1",
                        {status: 1, reqOrdId: reqOrdId}
                    )
                        .then((data) => {
                            if (data.items) {
                                this.lstImportWh = data.items;
                            }
                            this.calcTotalImportQuantity();
                        });
                });
        },
        //linhdx
        setTypeNameIfMissing(lstMaterial){
          let lst = new Array();
          for(let i = 0; i < lstMaterial.length; i ++){
             if(!this.isNullOrEmpty(lstMaterial[i].typeName)){
               let ob = {"typeId":lstMaterial[i].typeId, "typeName": lstMaterial[i].typeName}
               lst.push(ob);
             }
          }
          $.each(lstMaterial, function (k, v) {
                $.each(lst, function (k2, v2) {
                  if(v.typeId == v2.typeId){
                    v.typeName = v2.typeName
                  }
                });
            //lstMaterial[k].typeName = "ttt"
          });
          return lstMaterial
        },
        calcTotalImportQuantity() {
            const self = this;
            let lstMaterial = this.lstMaterialTmp;
            const lstImportWh = this.lstImportWh;
            let typeIdTmp = 0;
            let row = '';
            let typeName = '';
            // remove buyNumberPropose=0
            lstMaterial = this.setTypeNameIfMissing(lstMaterial)
            lstMaterial = lstMaterial.filter(function (v) {
                return v.buyNumberPropose != undefined && parseFloat(v.buyNumberPropose) > 0;
            });
            $.each(lstMaterial, function (k, v) {
                lstMaterial[k].supplyId = lstMaterial[k].supplySelected;
                let totalImport = 0;
                $.each(lstImportWh, function (k2, v2) {
                    const requestData = JSON.parse(v2.requestData);
                    const mate = requestData.find(function (o) {
                        return o.materialId == v.materialId;
                    });
                    if (mate != undefined) {
                        totalImport += parseFloat(mate.actualImport);
                    }
                });
                
                lstMaterial[k].totalImportQuantity = totalImport;

                lstMaterial[k].totalImportQuantityAcc = parseFloat(v.buyNumber) - totalImport;
                lstMaterial[k].orderQuantity = parseFloat(lstMaterial[k].buyNumberPropose) - totalImport;

                if (typeIdTmp != v.typeId) {
                    const mates = lstMaterial.filter(function (v2) {
                        return v2.typeId == v.typeId;
                    });
                    if (mates != undefined && mates.length > 0) {
                        lstMaterial[k].row = mates.length;
                    }
                    if (v.typeName != undefined) {
                        lstMaterial[k].typeName = v.typeName;
                    } else {
                      lstMaterial[k].typeName = ""
                        //lstMaterial[k].typeName = v.typeId;
                    }
                    typeIdTmp = v.typeId;
                } else {
                    lstMaterial[k].row = '';
                    lstMaterial[k].typeName = '';
                }
            });

            this.lstMaterial = lstMaterial;
        },
        getNextCode() {
            axios
                .get(
                    process.env.VUE_APP_API_URL +
                        "/autoIncrease/getNextCode?type=TB&prefix=TB/&numberZeroBeforeCodeNumberCode=2&suffix="
                )
                .then((data) => {
                    this.createItem.requestNumber = data;
                });
        },
        // updateQuantity($event) {
        //     const value = parseInt($event.target.value);
        //     const index = $event.currentTarget.getAttribute("data-index");
        //     // const item = this.lstMaterial[index];
        //     this.lstMaterial[index].orderQuantity = value;
        //     // if (item != undefined) {
        //         // const totalImportQuantity = item.totalImportQuantity != undefined ? item.totalImportQuantity : 0;
        //         // this.lstMaterial[index].orderQuantity = value;
        //         // this.lstMaterial[index].totalImportQuantityAcc = value - totalImportQuantity;
        //     // }
        // },

        keyProcess($event) {
            let index = parseInt($event.target.getAttribute("data-index"));
            let input_id = '';
            switch ($event.keyCode) {
                case 13:
                    index += 1;
                    input_id = "input_" + index;
                    var element = document.getElementById(input_id);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    } else {
                        $event.target.blur(); 
                    }
                    $event.preventDefault();
                    break;
                case 38:
                    // up
                    if (index > 0) {
                        index -= 1;
                        input_id = "input_" + index;
                        var element = document.getElementById(input_id);
                        if (typeof element != "undefined" && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 40:
                    //down
                    index += 1;
                    input_id = "input_" + index;
                    var element = document.getElementById(input_id);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    }
                    $event.preventDefault();
                    break;
            }
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        fomarLstSupplier(item) {
            let supplier = [];
            if (this.lstSupplier.length > 0 && this.lstMaterialFull.length > 0) {
                const material = this.lstMaterialFull.find(function (v) {
                    return item.materialId == v.materialId;
                });
                console.log(material);
                if (material != undefined) {
                    // const material = findMat[0];
                    const supplyId = ',' + material.supplyId + ',';
                    supplier = this.lstSupplier.filter(function (v) {
                        return supplyId.indexOf(',' + v.partnerId + ',') != -1;
                    });
                }
            }
            return supplier;
        },
        deleteItem(item) {
            const lstMaterial = this.lstMaterial;
            
            const typeId = item.typeId;
            const typeName = item.typeName;
            $.each(lstMaterial, function (k, v) {
                if (item.materialId != undefined && lstMaterial[k] != undefined && item.materialId == lstMaterial[k].materialId) {
                    lstMaterial.splice(k, 1);
                    return false;
                }
            });

            const listByTypeId = lstMaterial.filter(function (v) {
                return v.typeId == typeId;
            });
            if (listByTypeId !== undefined) {
                const row = listByTypeId.length;
                $.each(lstMaterial, function (k, v) {
                    if (lstMaterial[k].typeId == typeId) {
                        lstMaterial[k].row = row;
                        if (lstMaterial[k].typeName == '') {
                            lstMaterial[k].typeName = typeName;
                        }
                        return false;
                    }
                });
            }
        },
    },

    destroyed() {},
};
</script>
